import { gql } from '@apollo/client';

export const BULK_UPDATE_ENTITY_TAGS_MUTATION = gql`
  mutation BulkUpdateEntityTagsOperation(
    $entityIds: [ID!]!
    $tags: [String!]!
  ) {
    bulkUpdateEntityTags(entityIds: $entityIds, tags: $tags) {
      data {
        id
        tags
      }
    }
  }
`;

export const BULK_ADD_ENTITY_TAGS_MUTATION = gql`
  mutation BulkAddEntityTagsOperation($entityIds: [ID!]!, $tags: [String!]!) {
    bulkAddEntityTags(entityIds: $entityIds, tags: $tags) {
      data {
        id
        tags
      }
    }
  }
`;

export const BULK_REMOVE_ENTITY_TAGS_MUTATION = gql`
  mutation BulkRemoveEntityTagsOperation(
    $entityIds: [ID!]!
    $tags: [String!]!
  ) {
    bulkRemoveEntityTags(entityIds: $entityIds, tags: $tags) {
      data {
        id
        tags
      }
    }
  }
`;
